import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal/Modal.jsx';
import './ConfirmationModal.css';

const ConfirmationModal = ({
    isOpen,
    onClose,
    onConfirm,
    onCancel,
    title,
    message,
    confirmText,
    cancelText,
    confirmButtonClass = 'btn-danger',
    type = 'danger',
    loading = false,
    children
}) => {
    const { t } = useTranslation(['common']);

    const handleConfirm = () => {
        if (!loading) {
            onConfirm();
        }
    };

    const handleCancel = () => {
        if (onCancel) {
            onCancel();
        } else {
            onClose();
        }
    };

    // Determine button class based on type
    const buttonClass = confirmButtonClass || (type === 'danger' ? 'btn-danger' : 'btn-primary');

    return (
        <Modal
            isOpen={isOpen}
            onClose={handleCancel}
            title={title || t('common:confirmation')}
            footer={
                <>
                    <button 
                        type="button" 
                        onClick={handleCancel} 
                        className="btn btn-secondary"
                        disabled={loading}
                    >
                        {cancelText || t('common:buttons.cancel')}
                    </button>
                    <button 
                        type="button" 
                        onClick={handleConfirm}
                        className={`btn ${buttonClass}`}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <span className="spinner-small"></span>
                                {t('common:messages.loading')}
                            </>
                        ) : (
                            confirmText || t('common:buttons.confirm')
                        )}
                    </button>
                </>
            }
        >
            <div className="confirmation-modal-content">
                {message && <p>{message}</p>}
                {children}
            </div>
        </Modal>
    );
};

export default ConfirmationModal;